module.exports = __webpack_public_path__ + "img/horizontal_3_1_0.9e9a5785.png";